import { jsx as _jsx } from "react/jsx-runtime";
import CardActionArea from "@mui/material/CardActionArea";
import { useCsAttribute, useCsAttributeApi, useCsValue, useLocalOptionSelected, } from "@plansoft-configuration-renderer/framework";
/**
 * Renders basic wrapper around the content
 *
 * @category UI
 */
export function ThumbnailActionArea(props) {
    const attribute = useCsAttribute();
    const value = useCsValue();
    const { toggleOption } = useCsAttributeApi();
    const isSelected = useLocalOptionSelected();
    const isDisabled = Boolean(attribute.isReadOnly ||
        !attribute.isAllowed ||
        !value.isAllowed ||
        !value.isActive);
    return (_jsx(CardActionArea, { component: "div", disabled: isDisabled, onClick: () => toggleOption(value.value, !isSelected), children: props.children }));
}
//# sourceMappingURL=ThumbnailActionArea.js.map